// extracted by mini-css-extract-plugin
export default {"primary-item":"yugu","primary-item-menu":"GFZM","active":"lptX","secondary-item":"zDNe","has-tertiary":"i2Tg","sub-link":"VwdK","mobile-link":"jtp5"};